import { withSafeSuspense } from '@calendly/safe-suspense'
import { lazy } from 'react'

export const Branding = withSafeSuspense(lazy(
  async () => ({ default: (await import('./branding')).Branding })
))
